import React, { useState } from 'react';
import { 
    Dialog, DialogTitle, DialogContent, DialogActions, 
    Button, TextField, Box, Typography, IconButton, InputAdornment 
} from '@mui/material';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faKeyboard } from "@fortawesome/free-solid-svg-icons";

export default function CustomItemModal({ open, onClose, onAdd }) {
    const [name, setName] = useState('');
    const [price, setPrice] = useState('');
    const [quantity, setQuantity] = useState(1);

    const handleAdd = () => {
        const parsedPrice = parseFloat(price);
        const parsedQuantity = parseFloat(quantity);

        if (!name.trim() || isNaN(parsedPrice) || isNaN(parsedQuantity)) {
            alert("Por favor completa los campos correctamente.");
            return;
        }

        // Enviamos el producto al carrito con un ID único temporal
        onAdd({
            id: `custom-${Date.now()}`, // ID ficticio para que no choque con la BD
            name: name.trim(),
            price: parsedPrice,
            quantity: parsedQuantity,
            is_custom: true // Bandera útil por si el backend necesita saberlo luego
        });

        // Limpiar para la próxima vez
        setName('');
        setPrice('');
        setQuantity(1);
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <FontAwesomeIcon icon={faKeyboard} color="#64748b" />
                    <Typography variant="h6" fontWeight="700" color="#0F172A">Agregar Manualmente</Typography>
                </Box>
                <IconButton onClick={onClose} size="small"><FontAwesomeIcon icon={faClose}/></IconButton>
            </DialogTitle>
            
            <DialogContent dividers sx={{ p: 3, bgcolor: '#f8fafc', display: 'flex', flexDirection: 'column', gap: 2 }}>
                
                <Box>
                    <Typography variant="caption" fontWeight="700" color="text.secondary" mb={0.5} display="block">
                        NOMBRE DEL PRODUCTO / SERVICIO
                    </Typography>
                    <TextField 
                        fullWidth 
                        variant="outlined"
                        size="small"
                        placeholder="Ej: Empaque de Regalo"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        sx={{ bgcolor: 'white', '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                    />
                </Box>

                <Box sx={{ display: 'flex', gap: 2 }}>
                    <Box sx={{ flex: 1 }}>
                        <Typography variant="caption" fontWeight="700" color="text.secondary" mb={0.5} display="block">
                            PRECIO UNITARIO
                        </Typography>
                        <TextField 
                            fullWidth 
                            variant="outlined"
                            size="small"
                            type="number"
                            inputProps={{ step: 'any', min: '0' }}
                            placeholder="0.00"
                            value={price}
                            onChange={(e) => setPrice(e.target.value)}
                            InputProps={{
                                startAdornment: <InputAdornment position="start">$</InputAdornment>,
                            }}
                            sx={{ bgcolor: 'white', '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                        />
                    </Box>

                    <Box sx={{ flex: 1 }}>
                        <Typography variant="caption" fontWeight="700" color="text.secondary" mb={0.5} display="block">
                            CANTIDAD
                        </Typography>
                        <TextField 
                            fullWidth 
                            variant="outlined"
                            size="small"
                            type="number"
                            inputProps={{ step: 'any', min: '0.01' }}
                            value={quantity}
                            onChange={(e) => setQuantity(e.target.value)}
                            sx={{ bgcolor: 'white', '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                        />
                    </Box>
                </Box>

            </DialogContent>

            <DialogActions sx={{ p: 2, bgcolor: 'white' }}>
                <Button 
                    fullWidth 
                    variant="contained" 
                    onClick={handleAdd}
                    disabled={!name || !price || !quantity}
                    sx={{ py: 1.5, borderRadius: 2, fontWeight: '700', bgcolor: '#0ea5e9' }}
                >
                    Agregar al Carrito
                </Button>
            </DialogActions>
        </Dialog>
    );
}